import type { TShip, TShotsGrid } from '../types';

export function isShipSunk(ship: TShip, shots: TShotsGrid): boolean {
  for (const { col, row } of ship) {
    if (shots[row][col] !== 'hit') return false;
  }
  return true;
}

export function checkAllSunk(ships: TShip[], shots: TShotsGrid): boolean {
  for (const ship of ships) {
    if (!isShipSunk(ship, shots)) return false;
  }
  return true;
}
